var _g, _path, _circle, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNoResults = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 70,
  height: 74,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#no_results_svg__a)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 38.125,
  height: 42.125,
  x: 15.49,
  y: 12.217,
  fill: "url(#no_results_svg__b)",
  rx: 3.6
}), /*#__PURE__*/React.createElement("rect", {
  width: 40.525,
  height: 44.525,
  x: 14.29,
  y: 11.017,
  stroke: "#fff",
  strokeWidth: 2.4,
  rx: 4.801
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeWidth: 2,
  d: "M21.666 21.447a1.93 1.93 0 0 1 1.746-1.108h20.89a1.938 1.938 0 0 1 1.494 3.162l-6.95 8.494A8.34 8.34 0 0 0 36.96 37.3l.021 8.227c0 .585-.329 1.121-.856 1.383a1.55 1.55 0 0 1-1.62-.145l-3.095-2.322a1.54 1.54 0 0 1-.619-1.238l-.02-5.932a8.34 8.34 0 0 0-1.886-5.256l-6.972-8.52a1.93 1.93 0 0 1-.247-2.05Z"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 41.25,
  cy: 33.28,
  r: 6.675,
  fill: "url(#no_results_svg__c)",
  stroke: "#867AF2",
  strokeWidth: 2
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#867AF2",
  strokeLinecap: "round",
  strokeWidth: 2.619,
  d: "m39.259 31.29 3.981 3.98M43.24 31.29l-3.981 3.98"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "no_results_svg__b",
  x1: 15.49,
  x2: 53.615,
  y1: 33.28,
  y2: 33.28,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E5DBFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E8EDFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "no_results_svg__c",
  x1: 34.575,
  x2: 47.924,
  y1: 33.28,
  y2: 33.28,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E5DBFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E8EDFF"
})), /*#__PURE__*/React.createElement("filter", {
  id: "no_results_svg__a",
  width: 69.105,
  height: 73.105,
  x: 0,
  y: 0,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 3.272
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 6.545
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0.0352941 0 0 0 0 0.509804 0 0 0 0.15 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_25_1087"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_25_1087",
  result: "shape"
})))));
export default SvgNoResults;